import React from 'react'
import cx from 'classnames'

const StepLine = ({ className, ...rest }) => {
  return <div className={cx('step-line', className)} {...rest} />
}

export default StepLine
